import { annualHealthcareInflationRate } from './healthCareInflationRate';
import { isNullOrUndefined } from './isNullOrUndefined';

export function appliedHealthCareInflation(
  client: Client,
  asPercentage: boolean = false,
) {
  const {
    defaultHealthcareInflationPercent: advisorDefaultHealthcareInflationPercent,
  } = client.clientAdvisorSettings;
  const { healthCareInflationRate: clientHealthcareInflationRate } =
    client.clientCalculationSettings;

  let inflationRate = annualHealthcareInflationRate;

  if (!isNullOrUndefined(clientHealthcareInflationRate)) {
    inflationRate = clientHealthcareInflationRate;
  } else if (!isNullOrUndefined(advisorDefaultHealthcareInflationPercent)) {
    inflationRate = advisorDefaultHealthcareInflationPercent / 100;
  }

  return asPercentage ? inflationRate * 100 : inflationRate;
}

export function defaultHealthcareInflation(
  client: Client,
  asPercentage: boolean = false,
) {
  const { defaultHealthcareInflationPercent } = client.clientAdvisorSettings;

  // Calculate as a decimal between 0 and 1
  const inflationRate = !isNullOrUndefined(defaultHealthcareInflationPercent)
    ? defaultHealthcareInflationPercent / 100
    : annualHealthcareInflationRate;

  // Return as percentage if requested
  return asPercentage ? inflationRate * 100 : inflationRate;
}
